import { call, take, put }  from 'redux-saga/effects';
import axios                from 'axios';
import { 
  UPDATE_STUDENT_SCORES, 
  SET_STUDENT_SCORES, 
  SET_ENCODED_INFO,
  UPDATE_HASH,
  RECORD_ERROR_SAGA
}                           from '../actions';
import { 
  my_encoder, 
  create_time_limit_code,
  refineData,
  updateHash
}                           from '../functions/rectify_data/my_encoder';
import mockStudentScores    from '../data/mockData/mockStudentScores';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getStudentScores.php'


function* getStudentScores(): Generator<any,any,any> {
    while(true) {
      try {

        const input = yield take('GET_STUDENT_SCORES_SAGA');

        yield put(UPDATE_STUDENT_SCORES( false ));

        const { variant, userEmail, hash } = input.payload;

        const email = my_encoder(userEmail, false);

        const timeLimit = create_time_limit_code();

        const payload = { 
         userId:    email,
         timeLimit: timeLimit
        }
       
       yield put(SET_ENCODED_INFO( payload ))

       if (process.env.NODE_ENV === 'development') {

          const data = yield refineData(mockStudentScores);

          if ( variant === 'update' ) {
              const finalHash = yield updateHash(data, hash);
              yield put(UPDATE_HASH( finalHash ))
          }
          
          yield put(SET_STUDENT_SCORES( data ))
          yield put(UPDATE_STUDENT_SCORES( true ));

          console.log('GET_STUDENT_SCORES_SAGA')

       }


       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   
       // -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   -   


       else {

            /// get user activity from DB
 
            const response = yield call( 
              axios.post, 
              endpoint, 
              { userEmail: `${ email }` }
            )
            if (response.data) {

              if ( response.data.success && response.data.result ) {

                    const data = yield refineData(response.data.result);

                    if ( variant === 'update' ) {
                      const finalHash = yield updateHash(data, hash);
                      yield put(UPDATE_HASH( finalHash ))
                    }

                  //  console.log(JSON.stringify(data, null, 2))


                    yield put(SET_STUDENT_SCORES( data ))
                    yield put(UPDATE_STUDENT_SCORES(true));
                  
              }
              else { 
                yield put(UPDATE_STUDENT_SCORES(true));
              }
            }
            else {
              yield put(UPDATE_STUDENT_SCORES(true));
              console.log('no response - cannot get student info')
            }

            
       }
      }
      catch (err) {
        yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'GET_STUDENT_SCORES_SAGA' }))
        console.log('err  :  '+err);
      }
      finally {
        
      }
    }
  }

export default getStudentScores;

